import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../..";
import { useLocation, useNavigate } from "react-router-dom";
import { DIALOG_TYPES, DIALOGS } from "../../Dialogs/dialogReducer";
import { AlertThreeOptionsDialog } from "../../Dialogs/AlertThreeOptionsDialog";
import { signOut } from "firebase/auth";
import { auth } from "../../../firebase/firebaseConfig";
import { saveExam } from "../Functions/FunctionsMain";

const DiscardChangesExamDialog = ({ open, handleCancel }: { open: boolean; handleCancel: () => void }) => {
  const dispatch = useDispatch();
  const targetPath = useSelector((state: RootState) => state.dialogs.targetPath);
  const nameChanged = useSelector((state: RootState) => state.examBuilder.main.nameChanged);
  const examData = useSelector((state: RootState) => state.examBuilder.main.examData);
  const location = useLocation();
  const pathString = decodeURI(location.pathname.replace("/exam-builder", "")) || "/";
  const navigate = useNavigate();

  const user = useSelector((state: RootState) => state.app.user);
  const userId = user?.uid;

  async function navigateToTarget() {
    if (targetPath) {
      if (targetPath === "/") {
        try {
          await signOut(auth);
          dispatch({ type: "USER_LOGOUT" });
        } catch (error) {
          console.error(error);
        }
      }
      dispatch({ type: DIALOG_TYPES.CLOSE_DIALOG, payload: { dialogName: DIALOGS.DISCARD_CHANGES_EXAM_DIALOG } });
      navigate(targetPath);
    }
  }

  async function saveAndContinue() {
    if (userId) {
      await saveExam(userId, nameChanged, examData, pathString);
      navigateToTarget();
    } else {
      console.error("No User ID provided.");
    }
  }

  return (
    <AlertThreeOptionsDialog
      open={open}
      handleClose={() => handleCancel()}
      handleDiscardAndContinue={() => navigateToTarget()}
      handleSaveAndContinue={() => saveAndContinue()}
      title={`Ungespeicherte Änderungen`}
      text={`Du hast ungespeicherte Änderungen. Was sollen wir damit machen?`}
      cancelTitle="Abbrechen"
      discardTitle="Verwerfen"
      saveTitle="Speichern"
    />
  );
};

export default DiscardChangesExamDialog;
